import { Merchant } from "features/merchant/types";
export interface Auction {
	id?: number;
	car: { id: number; name: string; cover: string; publicCoverImage?: string };
	merchant: { id: number; fullName: string };
	status: AUCTION_STATUS;
	startDate: string;
	endDate: string;
	actualEndDate: string;
	startingPrice: number;
	expectPrice: number;
	updatedBy: number;
	currentBidding: number;
	bidIncrementType: AUCTION_BID_INCREMENT_TYPE;
	bidIncrement: number;
	createdAt?: string;
	updatedAt?: string;
	merchantRequestId: string | null;
	note: string;
	cancelReason?: string,
	bids?: number
}

export enum AUCTION_STATUS {
	PROCESSING = 1,
	UPCOMING = 2,
	COMPLETED = 3,
	CANCELED = 4,
}

export enum AUCTION_BID_INCREMENT_TYPE {
	PERCENTAGE = "percentage",
	FIXED = "fixed",
}

export interface AuctionQueryParams {
	skip: number;
	take: number;
	id?: string;
	merchant?: number | null;
	merchantName?: string;
	status?: string;
}

export interface AuctionFormSubmit {
	carId?: number | string;
	status?: AUCTION_STATUS;
	startDate?: string;
	endDate?: string;
	startingPrice?: number;
	expectPrice?: number;
	currentBidding?: number;
	bidIncrementType?: AUCTION_BID_INCREMENT_TYPE;
	bidIncrement?: number;
	merchantRequestId?: string;
	note?: string;
	cancelReason?: string,
	actualEndDate?: string
}

export interface Bid {
	id: number;
	auctionSectionId: number;
	carId: number;
	customerId: number;
	biddingPrice: number;
	currency: "usd";
	customer: {
		id: number;
		username: string;
		fullName: string;
	};
	createdAt: string;
	updatedAt: string;
}

export interface BidQueryParams {
	skip: number;
	take: number;
}
